import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from '@angular/material/tooltip';

const AVIARY_TOOLTIP_DEFAULTS: MatTooltipDefaultOptions = {
  showDelay: 300,
  hideDelay: 100,
  touchendHideDelay: 100,
  position: 'above'
};

export function provideAviaryTooltipDefaults(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: AVIARY_TOOLTIP_DEFAULTS}
  ]);
}
